<div [formGroup]="form" class="v4-filter-list py-[30px]">
  <div class="v4-filter-item">
    <v4-widget-input formControlName="title" placeholder="{{ 'placeholder.house_name' | translate }}"></v4-widget-input>
  </div>

  <div class="v4-filter-item">
    <host-select
      class="v4-filter-style"
      [placeholder]="'word.group' | translate"
      [listOfOption]="optionOfGroup"
      formControlName="group_id"
    ></host-select>
  </div>

  <div class="v4-filter-item">
    <v4-room-types-select class="v4-filter-style" formControlName="house_type_id"></v4-room-types-select>
  </div>

  <div class="v4-filter-item">
    <host-condition-switch-picker
      class="v4-filter-style"
      formControlName="tags"
      [placeholder]="'reservation.list.filters.filter_tag.placeholder' | translate"
      [listOfOption]="listOfLabel"
    ></host-condition-switch-picker>
  </div>

  <!-- <div class="v4-filter-item">
    <host-filters-picker
      [listOfOption]="listOfFilter"
      [(ngModel)]="filters"
      [ngModelOptions]="{ standalone: true }"
    ></host-filters-picker>
  </div> -->

  <div class="v4-filter-item">
    <button *ngIf="showResetBtn" nz-button nzType="text" (click)="onReset()">
      {{ "word.reset_filter" | translate }}
    </button>
  </div>
</div>
